import { HttpClient, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Response } from '@app/core/model';
import { Observable, filter, map } from 'rxjs';

import { SubtitlesFileValidationDataDTO, SubtitlesFileValidationDataModel } from '../../models';
import { isHttpResponse } from '@app/shared/utils';

interface ValidationResponse<Data> {
    body: Response<Data>;
}

@Injectable()
export class SubtitlesUploaderHttpsService {
    private readonly httpClient = inject(HttpClient);

    validateSubtitlesFile(formData: FormData, url: string): Observable<SubtitlesFileValidationDataModel> {
        const req = new HttpRequest('POST', url, formData);

        return this.httpClient.request(req).pipe(
            filter((event) => isHttpResponse(event)),
            map((event) => <ValidationResponse<SubtitlesFileValidationDataDTO>>(<unknown>event)),
            map((res) => new SubtitlesFileValidationDataModel(res.body.data)),
        );
    }
}
